/**
 * API 요청 시 백엔드 로그 맥락용 전역 상태 (Zustand)
 * - X-Screen, X-Request-Action 헤더로 전달되어 백엔드 MDC 로그에 표시됨
 * - 페이지/기능에서 setRequestContext(screen, action)으로 설정
 */
import { create } from 'zustand';

function createRequestContextStore(set) {
  return {
    screen: '',
    requestAction: '',

    /**
     * 현재 화면/액션 설정 (API 요청 시 헤더로 전달됨)
     * @param {string} screen - 화면 식별자 (예: document-write, approval-drafter)
     * @param {string} [requestAction] - 세부 동작 (예: list, write, view)
     */
    setRequestContext(screen, requestAction = '') {
      set({ screen: screen || '', requestAction: requestAction || '' });
    },

    resetRequestContext() {
      set({ screen: '', requestAction: '' });
    },
  };
}

const useRequestContextStore = create(createRequestContextStore);

export default useRequestContextStore;
